export const allCampaignsUrl = "/campaign/allCampaigns";
export const addCampaignUrl = "/campaign/addCampaign";
export const editCampaignUrl = "/campaign/editCampaign";
export const deleteCampaignUrl = "/campaign/deleteCampaign/{name}";
export const deleteAdditionalImageUrl =
  "/campaign/deleteAdditionalImage/{campaignName}/{numImage}";
